import { render, staticRenderFns } from "./ParticipantDetails.vue?vue&type=template&id=936521f4&"
import script from "./ParticipantDetails.vue?vue&type=script&lang=js&"
export * from "./ParticipantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports